'use client';
import Script from 'next/script';
import * as mobx from 'mobx';
import { useEffect, memo } from 'react';
import { NEXT_PUBLIC_CDN_URL, NEXT_PUBLIC_CDN_PREFIX, NEXT_PUBLIC_SSR_TAG, NEXT_PROD } from '@/shared/envs';

// Get NEXT_PUBLIC_FRONT_TAG injected by next.config.ts from front_tag.txt
const FRONT_TAG = process.env.NEXT_PUBLIC_FRONT_TAG;

export const CoreScript = memo(() => {
  console.log('Core mounted');

  // AI DON'T TOUCH THIS CODE START
  useEffect(() => {
    window.mobx = mobx;
    // Set base URL for core assets (for main.mjs to use)
    // Uses version tag from front_tag.txt: CDN_URL/core-builds/FRONT_TAG/core
    if (NEXT_PUBLIC_CDN_URL && FRONT_TAG && NEXT_PROD === "true") {
      const url = NEXT_PUBLIC_CDN_URL.endsWith('/') ? NEXT_PUBLIC_CDN_URL.slice(0, -1) : NEXT_PUBLIC_CDN_URL;
      window.CORE_BASE_URL = `${url}/core-builds/${FRONT_TAG}/core`;

      // Set soundfont URL to load from versioned CDN path instead of unversioned
      // Uses SSR version tag: CDN_URL/CDN_PREFIX/SSR_TAG/public/static/soundfont
      if (NEXT_PUBLIC_CDN_PREFIX && NEXT_PUBLIC_SSR_TAG) {
        const prefix = NEXT_PUBLIC_CDN_PREFIX.endsWith('/') ? NEXT_PUBLIC_CDN_PREFIX.slice(0, -1) : NEXT_PUBLIC_CDN_PREFIX;
        window.soundfontUrl = `${url}/${prefix}/${NEXT_PUBLIC_SSR_TAG}/public/static/soundfont`;
        window.metronomeClickUrl = `${url}/${prefix}/${NEXT_PUBLIC_SSR_TAG}/public/static/click.wav`;
        // Set WebAudioFont base URL to CDN
        window.WEBAUDIOFONT_BASE_URL = `${url}/${prefix}/${NEXT_PUBLIC_SSR_TAG}/public/static/webaudiofont/`;
      } else {
        // Fallback to unversioned path if SSR tag not available
        window.soundfontUrl = `${url}/public/static/soundfont`;
        window.metronomeClickUrl = `${url}/public/static/click.wav`;
        window.WEBAUDIOFONT_BASE_URL = `${url}/public/static/webaudiofont/`;
      }
    } else {
      window.CORE_BASE_URL = '/core';
      // In development, use local soundfont files
      window.soundfontUrl = '/static/soundfont';
      window.metronomeClickUrl = '/static/click.wav';
      window.WEBAUDIOFONT_BASE_URL = '/static/webaudiofont/';
    }

    // Trigger remount of core React app when navigating to pages with CoreScript
    // This handles the case where #root element is recreated during navigation
    // but main.mjs doesn't re-run (Script component only executes once)
    if (typeof (window as any).remountCoreApp === 'function') {
      console.log('[CoreScript] Triggering core app remount');
      (window as any).remountCoreApp();
    }
  }, []);
  // AI DON'T TOUCH THIS CODE END

  // Note: Orientation change handling moved to darpiano-front core (Player.ts)
  // The core now properly handles resize and orientation changes without page reload

  // Determine core script URL: use CDN with version tag if available
  let coreScriptUrl = '/core/main.mjs';
  if (NEXT_PUBLIC_CDN_URL && FRONT_TAG) {
    const url = NEXT_PUBLIC_CDN_URL.endsWith('/') ? NEXT_PUBLIC_CDN_URL.slice(0, -1) : NEXT_PUBLIC_CDN_URL;
    coreScriptUrl = `${url}/core-builds/${FRONT_TAG}/core/main.mjs`;
  }

  return (
    <>
      {/* Load core directly from CDN if specified, otherwise from hostname */}
      <Script
        type='module'
        src={coreScriptUrl}
        strategy='afterInteractive'
      />
      <div id='root' className='mb-16'></div>
    </>
  );
});

export default CoreScript;
